import { Base } from '@gate31/core/src/libs/BaseComponent';
import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import { ReviewsStatisticInt } from '@gate31/feature/reviews/reviews.types';

interface RenderOptions {
    reviewsStat: ReviewsStatisticInt;
    template: keyof LiquidTemplates;
}

export class ProductReviewsHeader extends Base<HTMLElement> {
    static cn = new Base.BuildCn('ProductReviewsHeader');

    render({ reviewsStat, template }: RenderOptions) {
        let rating = reviewsStat?.RatesTotalSum ? (reviewsStat?.RatesTotalSum / reviewsStat?.RecommendsTotalCount).toFixed(1) : '0.0';

        if (rating.includes('.0')) {
            rating = rating.replace('.0', '');
        }

        const content = LiquidRender.render(template, {
            rating,
            counter: reviewsStat?.ReviewsTotalCount || 0
        });

        this.getRoot().innerHTML = content;
    }
}
